export default "__VITE_ASSET__BECI5MoJ__"